import React, {Component} from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';

import { changeShopCollection, changeShopGender } from '../../store/actions/Shop';

function mapStateToProps(state) {
   return {
    shopData: state.shop.data,
    collection: state.shop.collection
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeShopCollection: (data) => {
      dispatch(changeShopCollection(data));
    },
    changeShopGender: (data) => {
      dispatch(changeShopGender(data));
    },
  }
}

class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {
    };
    this.changeCollection = this.changeCollection.bind(this);
    this.changeGender = this.changeGender.bind(this);
  }  

  changeCollection(e) {
    e.preventDefault();
    this.props.changeShopCollection(e.target.name)
  }

  changeGender(e) {
    e.preventDefault();
    this.props.changeShopGender(e.target.name)
  }

  render() {
    const { shopData, collection } = this.props;

    let t = this;
    let navList = shopData.map(function(shop) {
      return (
        <div className="ShopNav__thumbnail">
          <img name={shop.id} key={shop.name} src={shop.thumbnail} onClick={t.changeCollection} />
        </div>
      )
    })

    let typeList = (
      <div className="ShopNav__typelist">
        <a name="men" onClick={this.changeGender}>Mens</a>
        <a name="women" onClick={this.changeGender}>Womens</a>
        <a name="misc" onClick={this.changeGender}>Misc</a>
      </div>
    )

    return (
      <div className="ShopNav">
        <div className="ShopNav__navList">
          {navList}
        </div>
        { collection ? 
          <div>
            <h3>{shopData[collection].name}</h3>
            { collection.subNav ? typeList : null }
          </div>
          : null }
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);


// WEBPACK FOOTER //
// ./src/components/ShopNav/ShopNav.js